import { apiAccountProvider } from "./apiAccountProvider";
import { mockAccountProvider } from "./mockAccountProvider";
import { isMockEnabled } from "../../../config/featureConfig";

export const accountProvider = isMockEnabled("account")
  ? mockAccountProvider
  : apiAccountProvider;

